export default class TosClient {
  constructor({ url, _get }) {
    this.url = url
    this._get = _get
  }

  help() {
    console.log('get')
  }

  async get() {
    const url = `${this.url}/api/app/terms_of_service`
    return this._get(url, '')
  }
}
